
const eliminarP = (string) =>
{
    const etiqueta1 = string.replace("<p>", "");
    const limpio = etiqueta1.replace("</p>", "");
    return limpio;
}
export default eliminarP;
